import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import { StoreProductsAPI, WarehousesAPI } from "api";
import { settings } from "config";
import { useCallback, useRef, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "../styles.css";
import ProductViewModal from "../views/modal/ProductViewModal";

export default function ProductsTabContent({ storeId }) {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const location = useLocation();
  const columnApiRef = useRef();
  const gridRef = useRef();

  const [colDefs] = useState([
    {
      field: "name",
      headerName: "Name",
      hide: false,
      flex: 9,
    },
    {
      field: "category",
      headerName: "Category",
      hide: false,
      flex: 1.5,
    },

    {
      field: "status",
      headerName: "Active",
      hide: false,
      flex: 1.5,
      filter: false,
      cellStyle: {
        display: "flex",
        // paddingRight: "30px",
        justifyContent: "center",
      },
      headerClass: "center-header",
      cellRenderer: (p) => (
        <Form.Check
          type="checkbox"
          id="statusSwitch"
          style={{ padding: "10px 0px" }}
          checked={p?.data.status}
        />
      ),
    },
    // {
    //   field: "status",
    //   headerName: "Active",
    //   hide: false,
    //   flex: 1.5,
    //   filter: false,
    //   cellStyle: {
    //     display: "flex",
    //     // paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => (
    //     <Form.Check
    //       type="checkbox"
    //       id="statusSwitch"
    //       style={{ padding: "10px 0px" }}
    //       checked={p?.data.status}
    //     />
    //   ),
    // },
    // {
    //   headerName: "Action",
    //   field: "action",
    //   flex: 1.5,
    //   filter: false,
    //   cellStyle: {
    //     display: "flex",
    //     // paddingRight: "30px",
    //     justifyContent: "center",
    //   },
    //   headerClass: "center-header",
    //   cellRenderer: (p) => (
    //     <CardDropdown>
    //       <div className="py-2">
    //         <Dropdown.Item
    //           // as={Link}
    //           onClick={() =>
    //             // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
    //             // () =>
    //             handleRowClick(p.data)
    //           }
    //           // href="/products/add-product"
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdOutlineModeEdit />
    //           Edit
    //         </Dropdown.Item>
    //         {/* <Dropdown.Item
    //           // onClick={() => handleDelete()}
    //           className="d-flex align-items-center gap-2 py-0"
    //         >
    //           <MdDeleteOutline />
    //           Delete
    //         </Dropdown.Item> */}
    //       </div>
    //     </CardDropdown>
    //   ),
    // },
  ]);

  const [openViewModal, setOpenViewModal] = useState(null);

  const handleRowClick = (data) => {
    if (data) {
      setOpenViewModal(data);

      // navigate(`${CONSTANT_ROUTES.PRODUCT_VIEW_PAGE}`, { state: data });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    // flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const onGridReady = useCallback(
    (e) => {
      gridApi = e.api;
      columnApi = e.columnApi;
      StoreProductsAPI.get({ params: { storeId: storeId } }).then((res) => {
        e.api.applyTransaction({ add: res?.data?.data?.products });
      });
    },
    [window],
  );

  const saveState = useCallback(() => {
    saveColumnState("carts-table", columnApiRef);
  }, []);

  const restoreState = useCallback(() => {
    restoreColumnState("carts-table", columnApiRef);
  }, []);

  const resetState = useCallback(() => {
    resetColumnState("carts-table", columnApiRef);
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value,
    );
  }, []);

  return (
    <div
      className={`${
        isDarkBool || isDarkTheme || auto
          ? "ag-theme-quartz-dark"
          : "ag-theme-quartz"
      } rounded-0`} // applying the grid theme
      // style={{ height: "100vh" }} // the grid will fill the size of the parent container
    >
      <Card
        style={{
          height: `calc(80vh - 7rem)`,
          overflow: "auto",
        }}
        className="mt-2"
      >
        {/* <Card.Header className="d-flex justify-content-between align-items-center">
                        <BreadCrumbTable title="Shopenze" subTitle="Sellers" />
                        <div className="d-flex align-items-center gap-2">
                            <Form className="position-relative">
                                <FontAwesomeIcon
                                    icon="search"
                                    className="position-absolute text-400 search-box-icon"
                                    style={{
                                        left: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                    }}
                                />
                                <Form.Control
                                    type="search"
                                    placeholder="Search..."
                                    style={{
                                        paddingLeft: "30px",
                                    }}
                                    aria-label="Search"
                                    id="filter-text-box"
                                    className="rounded-pill search-input"
                                    onInput={onFilterTextBoxChanged}
                                />
                            </Form>
                        </div>
                    </Card.Header> */}

        <Card.Body className="p-0">
          <AgGridReact
            // rowData={rowData}
            ref={columnApiRef}
            onGridReady={onGridReady}
            pagination
            paginationPageSize={settings.paginationSize}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            onRowDoubleClicked={(params) => handleRowClick(params.data)}
            overlayNoRowsTemplate="Nothing found - Looks empty over here"
          />
        </Card.Body>
      </Card>

      <ProductViewModal
        show={openViewModal}
        onHide={() => setOpenViewModal(null)}
        data={openViewModal}
      />
    </div>
  );
}
